import { render, staticRenderFns } from "./GeneralStatisticsSmall.vue?vue&type=template&id=7cebe600"
import script from "./GeneralStatisticsSmall.vue?vue&type=script&lang=js"
export * from "./GeneralStatisticsSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports